import React, { useState, useEffect } from 'react'
import { isBillingAvailable } from '../_helpers/billing'
import OpenStackServicesEditService from './OpenStackServicesEditService'

const OpenStackServicesEdit = (props) => {
  const {
    configs,
    setConfigs,
    configOptions,
    setConfigOptions,
    supportedServiceConfigs,
    billingServicesConfigurable,
    identityProviderExists,
    validateFormFields,
    errors,
  } = props
  
  const [expandedPanel, setExpandedPanel] = useState('identity_keystone')
  const [serviceNames, setServiceNames] = useState([])
  const [filteredServiceNames, setFilteredServiceNames] = useState([])

  const handleChangeExpandedPanel = (panel) => (event, newExpanded) => {
    setExpandedPanel(newExpanded ? panel : false)
  }

  useEffect(() => {
    let service_names = []

    configs.forEach(item => {
      if (!service_names.includes(item.service_name)) {
        service_names.push(item.service_name)
      }
    })
    
    setServiceNames(service_names)
  }, [configs])

  useEffect(() => {
    setFilteredServiceNames(serviceNames.filter(item => isBillingAvailable(item, supportedServiceConfigs)))
  }, [serviceNames, supportedServiceConfigs])
  
  return (
    <>
      {
        filteredServiceNames.map((item, index) => (
          <OpenStackServicesEditService
            key={index}
            serviceName={item}
            configs={configs}
            setConfigs={setConfigs}
            configOptions={configOptions}
            setConfigOptions={setConfigOptions}
            supportedServiceConfigs={supportedServiceConfigs}
            billingServicesConfigurable={billingServicesConfigurable}
            expandedPanel={expandedPanel}
            handleChangeExpandedPanel={handleChangeExpandedPanel}
            identityProviderExists={identityProviderExists}
            validateFormFields={validateFormFields}
            errors={errors}
          />
        ))
      }
    </>
  )
}

export default OpenStackServicesEdit